import React from "react";
import { Carousel } from "react-responsive-carousel";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Center,
  Heading as HeadingC,
  useMediaQuery,
} from "@chakra-ui/react";
import { AspectRatio, Image, Skeleton, Stack } from "@chakra-ui/react";
import { useFeature } from "@growthbook/growthbook-react";
import { CardBody, CardFooter, CardHeader } from "@paljs/ui/Card";
import { useQuery } from "graphql-hooks";
import _ from "lodash";

import Layout from "../../components/layout";
import { Card, Col, Row } from "../../components/paljs";
import config from "../../config";
import { splitTurnusName } from "../../utils/helpers";

import {
  sem_1_2024_2025,
  sem_2_2024_2025,
  sem_1_2025_2026,
  sem_2_2025_2026,
  sem_1_2026_2027,
  summer2026,
  winter2027,
} from "./copy";
import { GET_SUMMER_CAMPS_2026, GET_WINTER_CAMPS_2027 } from "./data";

import "react-responsive-carousel/lib/styles/carousel.min.css";

type PromoCard = {
  header: string;
  subheader?: React.Component;
  body: string;
  path: string;
  images: string[];
  accent: string;
  customButtonLabel?: string;
};

export default function Offers() {
  const { show_summer_camp, show_winter_2027_camp } = config.FEATURE_TOGGLE;
  const [isLargerThan760] = useMediaQuery("(min-width: 760px)");
  const navigate = useNavigate();

  const summerCamps = useQuery(GET_SUMMER_CAMPS_2026, {
    useCache: false,
  });
  const winterCamps = useQuery(GET_WINTER_CAMPS_2027, {
    useCache: false,
  });

  const summerCamps2026 = _.get(summerCamps, "data.summer2026", []);
  const winterCamps2027 = _.get(winterCamps, "data.winter2027", []);

  const parsedSummer2026DescriptionRows = _.map(
    summerCamps2026,
    splitTurnusName
  );
  const parsedWinter2027DescriptionRows = _.map(
    _.sortBy(winterCamps2027, "name"),
    splitTurnusName
  );

  const summer2026Option = summer2026(
    _.reverse(parsedSummer2026DescriptionRows)
  );

  const winter2027Option = winter2027(parsedWinter2027DescriptionRows);

  const { on: showWinterCamp } = useFeature(show_winter_2027_camp);
  const { on: showSummerCamp } = useFeature(show_summer_camp);

  const options = _.reject(
    [
      showSummerCamp ? summer2026Option : {},
      showWinterCamp ? winter2027Option : {},
      sem_1_2026_2027,
    ],
    _.isEmpty
  ) as PromoCard[];

  const LoadingSkeleton = () => (
    <Stack>
      <Skeleton height="20px" />
      <Skeleton height="20px" />
      <Skeleton height="20px" />
      <Skeleton height="20px" />
      <Skeleton height="20px" />
    </Stack>
  );
  return (
    <Layout>
      <Center>
        <Col breakPoint={{ sm: 12 }}>
          <Row>
            <Col breakPoint={{ sm: 12, md: 6 }}>
              <Box mb={5} justifyContent="center">
                <HeadingC
                  fontSize={isLargerThan760 ? "2xl" : "xl"}
                  padding={0}
                  color={"gray.700"}
                >
                  Witaj w panelu Sportteam!
                </HeadingC>
              </Box>
            </Col>
          </Row>

          <Row>
            {_.map(options, (option, idx) => {
              return (
                <Col breakPoint={{ sm: 12, md: 6, xl: 4 }} key={idx} style={{ display: 'flex' }}>
                  <Box
                    onClick={() => navigate(option.path as string)}
                    style={{ cursor: "pointer", display: "flex", flex: 1 }}
                    className="grow"
                    m={3}
                  >
                    <Card accent={option.accent} style={{ flex: 1 }}>
                      <Box minH={220}>
                        <CardHeader>
                          <h4>{option.header}</h4>
                        </CardHeader>
                        {option.subheader && (
                          <CardBody>
                            <>{option.subheader}</>
                          </CardBody>
                        )}
                      </Box>
                      {_.size(option.images) === 1 ? (
                        <AspectRatio ratio={4 / 3}>
                          <Image
                            src={option.images[0]}
                            alt="sportteam logo"
                            objectFit="cover"
                          />
                        </AspectRatio>
                      ) : (
                        <Carousel
                          showArrows={false}
                          showStatus={false}
                          showIndicators={false}
                          showThumbs={false}
                          autoPlay={true}
                          interval={3000}
                          infiniteLoop={true}
                        >
                          {_.map(option.images, (path) => (
                            <img src={path} key={path} alt={option.header} />
                          ))}
                        </Carousel>
                      )}
                      <Box minH={180}>
                        <CardBody>
                          {!summerCamps.loading ? (
                            option.body
                          ) : (
                            <LoadingSkeleton />
                          )}
                        </CardBody>
                      </Box>
                      <CardFooter
                        style={{ marginTop: "auto" }}
                      >
                        <Center>
                          <Button
                            onClick={() => navigate(option.path as string)}
                          >
                            {option.customButtonLabel
                              ? option.customButtonLabel
                              : "Przejdź do zapisów"}
                          </Button>
                        </Center>
                      </CardFooter>
                    </Card>
                  </Box>
                </Col>
              );
            })}
          </Row>
        </Col>
      </Center>
    </Layout>
  );
}
